import { render, staticRenderFns } from "./EditLogistics.vue?vue&type=template&id=c409bc80&scoped=true&"
import script from "./EditLogistics.vue?vue&type=script&lang=js&"
export * from "./EditLogistics.vue?vue&type=script&lang=js&"
import style0 from "./EditLogistics.vue?vue&type=style&index=0&id=c409bc80&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c409bc80",
  null
  
)

export default component.exports